import {createContext, type PropsWithChildren, use, useMemo} from 'react'
import type {Paths} from '../types'

export const PathsContext = createContext<Paths | undefined>(undefined)

type PathsProviderProps = Paths

export function PathsProvider({children, paths}: PropsWithChildren<{paths: PathsProviderProps}>) {
  const value = useMemo(() => paths, [paths])

  return <PathsContext value={value}>{children}</PathsContext>
}

export function usePaths() {
  const context = use(PathsContext)
  if (!context) {
    throw new Error('usePaths must be used within a PathsProvider')
  }
  return context
}
